export enum ExternalPlayer {
  ShakaPlayer,
  WebMAF,
  UVPPlayer,
  JanusPlayer,
}
